import { Box, Flex, Heading, LaunchIcon, Link as IrisLink, Paragraph, Stack, Container } from "@eworkit/iris";
import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { useDialogState } from "reakit/Dialog";

import { LazyCircularCompanyAvatar } from "@/components/avatars/LazyCircularCompanyAvatar";
import { UserContext } from "@/components/User";
import { ICompany } from "@/data/companies";
import AddNewProfileDialog from "@/views/Invitations/AddNewProfileDialog";
import { router } from "@/views/router";

type DashboardCompanyProfileProps = {
  company: ICompany;
};

export const DashboardCompanyProfile: FC<DashboardCompanyProfileProps> = ({ company }) => {
  const { t } = useTranslation("session");
  const userContext = useContext(UserContext);
  const addNewProfileDialogState = useDialogState({ animated: true });

  const canAddProfile = userContext.hasCompanyManagerPrivileges();

  return (
    <Container>
      <Box pt={["0", null, null, "xs"]}>
        <Flex>
          <LazyCircularCompanyAvatar size="xl" company={company} />
          <Box pl="sm" flexGrow={2}>
            <Stack gap="xs">
              <Heading size={["h-sm", null, null, "h-md"]}>{company?.name}</Heading>
              {canAddProfile && (
                <Box>
                  <IrisLink onClick={() => addNewProfileDialogState.show()}>
                    <Paragraph size={["p-md", null, null, "p-lg"]}>
                      {t("DASHBOARD.PROFILE_SECTION.ADD_PROFILE")}
                    </Paragraph>
                  </IrisLink>
                </Box>
              )}
            </Stack>
          </Box>
          {canAddProfile && (
            <Box>
              <RouterLink to={router.get("company.settings").path}>
                <LaunchIcon className="launch-icon" size="sm" color="n700" />
              </RouterLink>
            </Box>
          )}
        </Flex>
      </Box>

      <AddNewProfileDialog dialogState={addNewProfileDialogState} />
    </Container>
  );
};
